export const environment = {
  production: false,
  B2E_clientId: '1e1c3549-9b7c-4de4-8549-9f7c34d65927',
  B2E_scope: [
    // 'openid',
    // 'profile',
    'api://1e1c3549-9b7c-4de4-8549-9f7c34d65927/app_access',
  ],
  redirectURI: 'https://gpd-rzd.ams1907.com/',

  // Temporariily setting API to point to Genesis environment
  // apiUrl: 'https://b2c.ams1907.com/gpdwebrdf/',
  // fileUploadUrl: 'https://b2c.ams1907.com/gpdwebrdf/gpd-file-upload/',

  apiUrl: 'https://genesis.inside.ams1907.com/gpd/web/v2/',
  fileUploadUrl: 'https://genesis.inside.ams1907.com/v2/gpd-file-upload/',
};
